import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IpAddressService {
  ipAddress = new BehaviorSubject<string>('');

  constructor(private http: HttpClient) {}

  public getIpAddress() {
    return this.http
      .get<{ ip: string }>('https://api.ipify.org/?format=json')
      .pipe(
        take(1),
        tap((value) => this.ipAddress.next(value.ip)),
        catchError((err) => {
          console.error('idAddressService getIpAddress', err);
          return of({ ip: null });
        })
      );
  }

  get ip() {
    return this.ipAddress.value;
  }
}